module.exports = __webpack_public_path__ + "static/media/1POLICY13.63f6fad0.jpg";